export default "__VITE_ASSET__DKcrRsF$__"